import { render, staticRenderFns } from "./vLink.vue?vue&type=template&id=a34b40a4&"
import script from "./vLink.vue?vue&type=script&lang=js&"
export * from "./vLink.vue?vue&type=script&lang=js&"
import style0 from "./vLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports